<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <input type="text" placeholder="ابحث هنا..." v-model="q">
            <table class="table table-sm table-bordered table-striped">
                <thead>
                    <th>
                        م
                    </th>
                    <th>
                        رقم الطلب
                    </th>
                    <th>
                        العميل
                    </th>
                    <th>
                        التاريخ
                    </th>
                    <th>
                        حالة الطلب
                    </th>
                </thead>
                <tbody>
                    <template v-for="(u, i) in orders">
                        <tr v-if="u.order_id.includes(q) || q == '' || !q" :key="u._id">
                            <td>
                                {{ orders.length - i }}
                            </td>
                            <td>
                                {{ u.order_id }}
                            </td>
                            <td>
                                {{ u.user.name }}
                                <br>
                                {{ u.user.phone }}
                            </td>
                            <td>
                                {{ u.date.split(" ")[0] }}
                            </td>
                            <td>
                                <select @change="changeStatus(u)" :class="`form-control form-control-sm ${u.status == 0 ? 'bg-warning' : (u.status == 1 ? 'bg-success' : 'bg-danger')} text-white`" v-model="u.status" style="min-width: 100px">
                                    <option :value="0">في الانتظار</option>
                                    <option :value="1">تم بنجاح</option>
                                    <option :value="2">فشل</option>
                                </select>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import templates from '../../../../Vuejs/src/views/pages/templates.vue';
export default {
  components: { templates },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            users: [],
            orders: [],
            q: ""
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post("https://server-enjazfile.tahdir.net/admin/users", {
                token: "5289765479"
            }).then(function(r){
                g.users = r.response;
                $.post("https://server-enjazfile.tahdir.net/admin/orders", {
                    token: "5289765479"
                }).then(function(r){
                    g.orders = r.response.map(function(x){
                        x.user = {};
                        g.users.forEach(function(a){
                            if(a._id == x.user_id){
                                x.user = a;
                            }
                        })
                        return x;
                    })
                })
            })
        },
        checkdate(date){
            if(new Date(date).getTime() >= new Date().getTime()){
                return 'text-success'
            }
        },
        changeStatus(u){
            var g = this;
            $.post("https://server-enjazfile.tahdir.net/admin/orders/status", {
                token: "5289765479",
                _id: u._id,
                status: u.status
            }).then(function(r){
                alert('تم تغيير الحالة بنجاح')
            })
        },
        checkusercolor(exdate){
            const oneDay = 24 * 60 * 60 * 1000;
            const firstDate = new Date();
            const secondDate = new Date(exdate);
    
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

            if(firstDate.getTime() <= secondDate.getTime()){
                if(diffDays >= 10){
                    return 'bg-light-success'
                }
            }else{
            }
        },
        password(u){
            var g = this;
            var t = prompt("كلمة المرور", u.password);
            if(t != u.password && t && t != ""){
                $.post("https://server-enjazfile.tahdir.net/admin/users/password", {
                    token: "5289765479",
                    user_id: u._id,
                    password: t
                }).then(function(r){
                    alert('تم تغيير كلمة المرور بنجاح')
                })
            }
        },
        exdate(u){
            var g = this;
            var t = prompt("تاريخ الانتهاء", u.exdate);
            if(t != u.exdate && t && t != ""){
                $.post("https://server-enjazfile.tahdir.net/admin/users/exdate", {
                    token: "5289765479",
                    user_id: u._id,
                    exdate: t
                }).then(function(r){
                    alert('تم تغيير التاريخ بنجاح')
                })
            }
        },
    }
}
</script>

<style>

</style>